/**
 * Classe pour la gestion d'un utilisateur
 */

import i18n from '@js/i18n';

export default class UserModel {

    // object: data

    /**
     * Constructeur
     * @param object data
     */
    constructor(data) {
        this.data = data;
    };

    /**
     * Retourne la langue de l'utilisateur
     * @return string
     */
    getLang() {
        const settings = (this.data.settings ?? {});
        return (settings.applicationLang ?? i18n.global.locale);
    };

    /**
     * Retourne si l'utilisateur est un manager d'agence
     * @return true
     */
    isAgencyManager() {
        return (this.data.type === 'AGENCY_MANAGER');
    };

    /**
     * Retourne si l'utilisateur est un agent
     * @return true
     */
    isAgent() {
        const allowedTypes = [ 'INTERNAL_AGENT', 'EXTERNAL_AGENT' ];
        return (allowedTypes.indexOf(this.data.type) !== -1);
    };

    /**
     * Retourne si l'utilisateur est un manager d'agent
     * @return bool
     */
    isTeamManager() {
        return (this.data.type === 'TEAM_MANAGER');
    };

    /**
     * Retourne si l'utilisateur est un client
     * @return bool
     */
    isCustomer() {
        return (this.data.type === 'CUSTOMER');
    };

    /**
     * Retourne si l'utilisateur peut faire une demande de congés
     * @return bool
     */
    canRequestHolidays() {
        // Un contrat doit être actif
        if(! this.data.contract || ! this.data.contract.isActive) {
            return false;
        }
        if(this.data.type === 'EXTERNAL_AGENT') {
            return true;
        }
        return ((this.data.contract.nbHolidaysRemaining - this.data.contract.nbHolidaysWaiting) > 0);
    };

};
